import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/page_cajamarca.jpg")